module.exports = __webpack_public_path__ + "static/media/new-soal-icon.ea6f0e9c.svg";